import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
// import useStyles from "../dashAuction.style";
import getMyBidLogAPI from "../../../../api/getMyBidLogAPI";
import Typography from "@mui/material/Typography";
import moment from "moment";
import {
  getToken,
  getUserData,
  getTimeZone,
  localTimeZone,
  localSetTimeZone,
} from "../../../../common";
import { DATE_TIME_DISPLAY, dateSortValue } from "../../../../common/dateTime";

function BidModal({ eventId, eventItemId }) {
  // const classes = useStyles();
  console.log("BidModal called");
  const getZone = getTimeZone() ? getTimeZone() : localTimeZone();

  const [tableEventItemBidData, setTableEventItemBidData] = useState([]);

  const fetchBidLog = async () => {
    try {
      const { data } = await getMyBidLogAPI(eventId, eventItemId);
      if (data) {
        const list = Array.isArray(data) ? data : data.data;
        if (list) {
          let id = 1;
          const eventsData = list.map((eventItem, index) => {
            return {
              id: id++,
              lotNumber: eventItem.lotNumber,
              buyerName: eventItem.buyerName || "You",
              bidPrice: eventItem.amount,
              bidDateTimeSortValue: dateSortValue(eventItem.biddingTime),
              bidDateTime: moment(eventItem.biddingTime)
                .tz(getZone)
                .format(DATE_TIME_DISPLAY),
            };
          });
          setTableEventItemBidData(eventsData);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchBidLog();
  }, [eventId, eventItemId]);

  const nextColumns = [
    {
      name: "Sr.",
      selector: "id",
      cell: (data) => String(data.id),
      sortable: true,
    },
    {
      name: "Lot No",
      selector: "lotNumber",
      cell: (data) => String(data.lotNumber),
      sortable: true,
    },
    {
      name: "Amount",
      selector: "bidPrice",
      cell: (data) => Number(data.bidPrice),
      sortable: true,
    },
    {
      name: "Bid Date And Time",
      selector: (row) => row.bidDateTimeSortValue,
      cell: (data) => String(data.bidDateTime),
      sortable: true,
    },
  ];

  return (
    <>
      <div className="AuctionTable">
        <h3>Bid Log</h3>
        <DataTableExtensions
          print={false}
          export={false}
          exportHeaders={false}
          columns={nextColumns}
          data={tableEventItemBidData}
        >
          <DataTable
            noHeader
            defaultSortField="id"
            defaultSortAsc={false}
            pagination={true}
            highlightOnHover
            className="DataTable"
          />
        </DataTableExtensions>
      </div>
    </>
  );
}

export default BidModal;
